import { ConnectionAppManager, Variables } from 'core/index';

import { ActivitiesApp } from 'apps/home/activityFeed/app';

export class ActivityConnManager extends ConnectionAppManager {
  static ArrayApp = ActivitiesApp;
  constructor(parent, init = {}) {
    super(parent, init);
    this.initialBatchSize = 20;
    this.batchSize = 10;

    this.variables = new Variables({
      batchSize: () => {
        if (this.loadedMore) {
          return this.batchSize;
        }
        return this.initialBatchSize;
      },
      cursor: () => this.endCursor,
    });
    this.loadMoreQuery = init.loadMoreQuery;
  }
}
